var _classCallCheck = require("/codebuild/output/src366346879/src/procrain-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src366346879/src/procrain-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/codebuild/output/src366346879/src/procrain-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/codebuild/output/src366346879/src/procrain-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _require = require('stream'),
    Transform = _require.Transform;

module.exports = function (KeccakState) {
  return /*#__PURE__*/function (_Transform) {
    "use strict";

    _inherits(Shake, _Transform);

    var _super = _createSuper(Shake);

    function Shake(rate, capacity, delimitedSuffix, options) {
      var _this;

      _classCallCheck(this, Shake);

      _this = _super.call(this, options);
      _this._rate = rate;
      _this._capacity = capacity;
      _this._delimitedSuffix = delimitedSuffix;
      _this._options = options;
      _this._state = new KeccakState();

      _this._state.initialize(rate, capacity);

      _this._finalized = false;
      return _this;
    }

    _createClass(Shake, [{
      key: "_transform",
      value: function _transform(chunk, encoding, callback) {
        var error = null;

        try {
          this.update(chunk, encoding);
        } catch (err) {
          error = err;
        }

        callback(error);
      }
    }, {
      key: "_flush",
      value: function _flush() {}
    }, {
      key: "_read",
      value: function _read(size) {
        this.push(this.squeeze(size));
      }
    }, {
      key: "update",
      value: function update(data, encoding) {
        if (!Buffer.isBuffer(data) && typeof data !== 'string') throw new TypeError('Data must be a string or a buffer');
        if (this._finalized) throw new Error('Squeeze already called');
        if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding);

        this._state.absorb(data);

        return this;
      }
    }, {
      key: "squeeze",
      value: function squeeze(dataByteLength, encoding) {
        if (!this._finalized) {
          this._finalized = true;

          this._state.absorbLastFewBits(this._delimitedSuffix);
        }

        var data = this._state.squeeze(dataByteLength);

        if (encoding !== undefined) data = data.toString(encoding);
        return data;
      }
    }, {
      key: "_resetState",
      value: function _resetState() {
        this._state.initialize(this._rate, this._capacity);

        return this;
      }
    }, {
      key: "_clone",
      value: function _clone() {
        var clone = new Shake(this._rate, this._capacity, this._delimitedSuffix, this._options);

        this._state.copy(clone._state);

        clone._finalized = this._finalized;
        return clone;
      }
    }]);

    return Shake;
  }(Transform);
};